import { FC } from "react";
import ExitCross from "../../../../assets/cancelGreey.svg";

interface TaskFormHeaderProps {
    widgetMode: string;
    onClose: () => void;
}

const TaskFormHeader: FC<TaskFormHeaderProps> = ({ widgetMode, onClose }) => {
    return (
        <div className="task__create--edit__form--header">
            <div className="task__create--edit__form--head">{widgetMode}</div>
            <div className="task__create--edit__form--button">
                <button onClick={onClose}>
                    <img src={ExitCross} alt="Close" />
                </button>
            </div>
        </div>
    );
};

export default TaskFormHeader;